import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  required,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router";

import { validateDomain } from "./validators";
import DomainManagerSelectInput from "./DomainManagerSelectInput";
import useCreateWithValidation from "../common/useCreateWithValidation";
import FormContainer from "../common/FormContainer";

const DomainCreate = () => {
  const location = useLocation();
  // Read initial values from the location which is injected by React Router and passed to our component by react-admin automatically
  const { customerId, mainDomainId } = parse(location.search);

  const save = useCreateWithValidation("Domain", { redirectTo: "show" });

  return (
    <Create>
      <SimpleForm defaultValues={{ customerId, mainDomainId }} onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput optionText="name" fullWidth validate={required()} />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="mainDomainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ isMainDomain: true, customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                allowEmpty
                {...rest}
              >
                <AutocompleteInput
                  optionText="unicodeName"
                  emptyText="- keine -"
                  fullWidth
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <TextInput
            source="domain"
            validate={validateDomain}
            helperText="Domain Name (ASCII), keine Sonderzeichen"
            fullWidth
          />
          <DomainManagerSelectInput
            source="managedBy"
            validate={required()}
            fullWidth
          />
          <BooleanInput source="mailEnabled" />
        </FormContainer>
      </SimpleForm>
    </Create>
  );
};
export default DomainCreate;
